export default function CTASection() {
  return (
    <section className="relative w-full h-[480px] md:h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20product%20display%20with%20diverse%20fashion%20items%20including%20leather%20goods%20scarves%20and%20accessories%20on%20natural%20linen%20draped%20surface%2C%20soft%20sunset%20light%20streaming%20through%20window%2C%20minimalist%20artistic%20photography%20with%20organic%20textures%20and%20dried%20branches&width=1800&height=800&seq=cta-bg-fresh-v2&orientation=landscape"
          alt="Start exploring the Vigorbuy Spreadsheet today"
          title="Vigorbuy Spreadsheet CTA — Start Exploring"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl text-white leading-tight mb-6 tracking-wide">
          START EXPLORING THE<br />LATEST VIGORBUY SPREADSHEET
        </h2>
        <p className="text-white/75 text-sm md:text-base max-w-xl mx-auto mb-10 leading-relaxed">
          Join thousands of savvy shoppers who save time and discover better products every day with the updated <strong>Vigorbuy Spreadsheet</strong>.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          BUY IT NOW
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}